import { useNavigate } from 'react-router-dom';
import './btn_transition.css';


function BtnTransition(props) {

    const nav = useNavigate();

    let hasBackBtn = props.hasBackBtn;
    let goToBack = props.goToBack;
    let hasNextBtn = props.hasNextBtn;

    const backTo = (e) => {
        e.preventDefault();
        nav(goToBack);
    }

    return (
        <div className='btn__submit-container'>
            <button id='btn__back' style={{ 'visibility': `${hasBackBtn ? 'visible' : 'hidden'}` }} onClick={(e) => backTo(e)} >Go Back</button>
            <button id='btn__submit' type='submit' style={{ 'visibility': `${hasNextBtn ? 'visible' : 'hidden'}` }} >Next Step</button>
        </div>
    )
}

export default BtnTransition;